import type { FC, ReactNode } from "react";
import { useTranslation } from "react-i18next";
import classes from "./Step.module.scss";

interface StepProps {
	title: string;
	children: ReactNode;
	count: number;
}

export interface StepComponent extends FC<StepProps> {}

export const Step: StepComponent = ({ title, children, count }) => {
	const { t } = useTranslation();
	return (
		<div className={classes.wrapper}>
			<div className={classes.content}>
				<div className={classes.number}>
					{t("translation.step")} {count}
				</div>
				<h4 className={classes.title}>{title}</h4>
			</div>
			<div className={classes.text}>{children}</div>
		</div>
	);
};
